import React, { useMemo } from "react";

import Sidebar from "../../Sidebar";
import ErrorContent from "./ErrorContent";
import styles from "./style.module.css";

const ErrorComponent = ({ isAuthenticated, error, ...rest }) => {
  const errorComponentTitleAndSubtitle = useMemo(() => {
    if (typeof error?.name === "string" && error?.name?.includes("ChunkLoadError")) {
      return {
        title: "Update Available",
        subtitle:
          "A new version of the application is ready. Please refresh your browser to access the latest features.",
      };
    }

    return {};
  }, [error]);

  if (isAuthenticated) {
    return (
      <div className={styles.container}>
        <Sidebar />
        <div className={styles.contentContainer}>
          <ErrorContent {...rest} {...errorComponentTitleAndSubtitle} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <ErrorContent {...rest} {...errorComponentTitleAndSubtitle} />
    </div>
  );
};

export default ErrorComponent;
